module.exports = __webpack_public_path__ + "img/jiaguo.f90d661f.png";